var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-header",class:[_vm.sortField?("sort-field-" + _vm.sortField):'sort-none', ("sort-order-" + (_vm.sortAsc?'asc':'desc'))]},[_c('tr',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }